<template>
  <ul v-if="items.length > 0" class="list--simple result-grid sightings-grid">
    <li v-for="usimage in items" :key="usimage.sha1" class="result-grid__item sha1">
      <p>SHA1: <span class="sha1-number">{{ usimage.sha1 }}</span></p>
      <span>No sightings for this SHA1</span>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'noSightingsItems',
  props: {
    items: {
      type: Array
    },
  },
}
</script>

<style>
.result-grid__item.sha1 {
  width: 48%;
}
.sha1-number {
  width: 88%;
  display: inline-block;
  border: 1px solid;
  padding: 5px;
  background: #fff;
}
</style>
